/**
 * 浏览器版本，只有 HTTP 上报
 */
import '../util/polyfill';
import type { HttpWeblogInitParams } from '@/types/configuration';
import Weblog from '@/platform/browser';
import { BasePlugin } from '../plugins/base';
export type {
    SupportTypes,
    SendConfig,
    PVOptions,
    ShowOptions,
    TaskOptions,
    CustomOptions,
    BaseOptions,
    VideoEventOptions,
} from './types';
import { addClass, initSilence } from '@/util/namespace';
export type LoggerConfigByUser = HttpWeblogInitParams[0];
export type WeblogInitParams = HttpWeblogInitParams;
// 注册到全局对象
addClass(Weblog);
initSilence();

export {
    Weblog,
    BasePlugin,
};

export default Weblog;
